import React from 'react';
import {useTranslation} from 'react-i18next';
import somethingWrongIcon from '../../../assets/something-wrong-icon.png';
import {ButtonModal, Description, Title} from './styled';
import Modal from '../../../components/Modal';

type ReservationNotFoundModalProps = {
  open: boolean;
  onNext: () => void;
  onClose: () => void;
};

function ReservationNotFoundModal({
  open,
  onNext,
  onClose,
}: ReservationNotFoundModalProps) {
  const {t} = useTranslation();

  return (
    <Modal
      open={open}
      withCloseButton
      onClose={onClose}
      title={<Title>{t('provide_more_details')}</Title>}
      text={<Description>{t('provide_more_details_description')}</Description>}
      iconSrc={somethingWrongIcon}
      iconProps={{width: 110, height: 110}}
    >
      <ButtonModal onClick={onNext} label={t('ok')} />
    </Modal>
  );
}

export {ReservationNotFoundModal};
